export default "__VITE_ASSET__CfUDb$ed__"